var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRotateRightTool(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rotate-right-tool_svg__clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 17,
    height: 15,
    rx: 3,
    transform: "scale(-1 1) rotate(5 -111.32 -239.69)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26 14c1-5-3-10-9-8",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#rotate-right-tool_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.737 12h.526c1.645 0 2.467 0 2.75.528.283.528-.173 1.213-1.086 2.581l-.263.395c-.753 1.129-1.129 1.693-1.664 1.693-.535 0-.912-.564-1.664-1.693l-.263-.395c-.913-1.368-1.369-2.053-1.086-2.58C23.27 12 24.092 12 25.737 12z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rotate-right-tool_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 32 0)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rotate-right-tool_svg__filter0_d",
    x: 19.904,
    y: 10,
    width: 12.193,
    height: 11.197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRightTool);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cmVjdCBvcGFjaXR5PSIwLjQiIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNSIgcng9IjMiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjk5NjE5NSAwLjA4NzE1NTcgMC4wODcxNTU3IDAuOTk2MTk1IDIxLjMxNCA4Ljc5MDA0KSIgZmlsbD0iYmxhY2siLz4KPHBhdGggb3BhY2l0eT0iMC40IiBkPSJNMjUuOTk5OSAxNEMyNi45OTk5IDkgMjIuOTk5OSA0IDE2Ljk5OTkgNiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPgo8cGF0aCBkPSJNMjUuNzM3IDEySDI2LjI2M0MyNy45MDggMTIgMjguNzMwNSAxMiAyOS4wMTMyIDEyLjUyODFDMjkuMjk1OCAxMy4wNTYzIDI4LjgzOTYgMTMuNzQwNyAyNy45MjcxIDE1LjEwOTRMMjcuNjY0MSAxNS41MDM4QzI2LjkxMTUgMTYuNjMyOCAyNi41MzUyIDE3LjE5NzIgMjYgMTcuMTk3MkMyNS40NjQ4IDE3LjE5NzIgMjUuMDg4NSAxNi42MzI4IDI0LjMzNTkgMTUuNTAzOEwyNC4wNzI5IDE1LjEwOTRDMjMuMTYwNCAxMy43NDA3IDIyLjcwNDIgMTMuMDU2MyAyMi45ODY4IDEyLjUyODFDMjMuMjY5NSAxMiAyNC4wOTIgMTIgMjUuNzM3IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2QiIHg9IjE5LjkwMzYiIHk9IjEwIiB3aWR0aD0iMTIuMTkyNyIgaGVpZ2h0PSIxMS4xOTcyIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQgZHk9IjEiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMS41Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjQgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDMyIDApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };